module.exports = __webpack_public_path__ + "img/agents-xs.bb164ea3.svg";